import React, { Component, Suspense } from "react";
import { connect } from "react-redux";
import { Box, GlobalStyle } from "./style";
import { FullScreenLoading } from "../../components/loading";
class Index extends Component {
  componentDidMount() {
    let meta = document.createElement("meta");
    meta.name = "viewport";
    meta.content = "width=device-width, initial-scale=1";
    document.getElementsByTagName("head")[0].appendChild(meta);
  }
  render() {
    const { Component, route } = this.props;
    return (
      <React.Fragment>
        <GlobalStyle />
        <Box>
          <Suspense fallback={<FullScreenLoading />}>
            <Component route={route} />
          </Suspense>
        </Box>
      </React.Fragment>
    );
  }
}

export default connect()(Index);
